import { ServiceStatus } from '../../../constants/service.constants';
import { AppsyncConnector } from './connector';
import {
	CreateFastTrackLeapEnrollmentRequest,
	createFastTrackEnrollmentRequest,
	ServiceEnrollmentData,
	onCreateCard,
	OnCreateCardData,
} from './mutation';

export default class FasttrackConnector extends AppsyncConnector {
	
	protected get patientId() {
		return undefined;
	}
	protected get enrollmentQuery(): string {
		return createFastTrackEnrollmentRequest;
	}
	protected get subscriptionQuery(): string {
		return onCreateCard(this.sessionToken!);
	}

	protected getServicesFromMutation(
		response: CreateFastTrackLeapEnrollmentRequest
	): string[] {
		return [response.data.createFastTrackEnrollment.service];
	}

	protected getDataFromSubscription(
		response: OnCreateCardData
	): ServiceEnrollmentData {
		const card = response.data.onCreateCard;
		return {
			service: card.type,
			state: {
				state: ServiceStatus.enrolled,
			},
			userSessionId: this.sessionToken!,
			card: {
				items: [
					{
						digitalWalletKey: card.digitalWalletKey,
						memberId: card.memberId,
						bin: card.bin,
						group: card.group,
						pcn: card.pcn,
					},
				],
			},
		};
	}

	protected getRequestBody() {
		return {
			userSessionId: this.sessionToken,
			product: this.request?.product,
			service: 'copay',
		};
	}
}
